export default __webpack_public_path__ + "static/media/cat.1c2805bd.png";